import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTranslation } from '../../utils';
import { Spinner } from '../common';
import Button from '../ui/button';
import { XIcon } from '@phosphor-icons/react';

export default function PrivacyConsent({ onConfirm, onClose, orgPrefix, isLoading = false }) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          disabled={isLoading}
          className="absolute top-4 left-4 text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
          <XIcon size={24} />
        </button>

        {/* Content */}
        <div className="text-center my-6">
          <h2
            className="text-xl font-bold text-gray-800 mb-2"
            dangerouslySetInnerHTML={{
              __html: getTranslation(t, 'popups.privacy.title', orgPrefix)
            }}
          />
        </div>

        <div className="text-gray-700 mb-6 text-lg text-center leading-relaxed">
          <p
            dangerouslySetInnerHTML={{
              __html: getTranslation(t, 'popups.privacy.description', orgPrefix)
            }}
          />
        </div>

        {/* Confirm Button */}
        <Button.ButtonRounded
          onClick={onConfirm}
          disabled={isLoading}
          bgColor="secondary"
          className="w-full max-w-xs mx-auto py-3">
          <Spinner isSubmitting={isLoading} />
          {getTranslation(t, 'popups.privacy.confirmButton', orgPrefix)}
        </Button.ButtonRounded>
      </div>
    </div>
  );
}
